/* eslint-disable max-lines */
import moment from 'moment';

export const generateRepositories = ({
  isActive,
  isOrg,
  ownerName,
  number,
  isNew
}) => {
  const repositories = [];
  for (let i = 0; i < number; ++i) {
    repositories.push({
      contrib_count: -1,
      created_at: '2020-07-06T03:28:12',
      description: 'Python shared code module',
      http_url: 'https://github.com/Talhashahar/wise_trash.git',
      id: Math.floor(Math.random() * 2147483647),
      language: null,
      main_branch: 'develop',
      name: 'linpy',
      owner_login: ownerName,
      owner_type: isOrg ? 'Organization' : 'User',
      size: 895,
      ssh_url: 'git@github.com:ariel-linearb/linpy.git',
      updated_at: isActive ? moment() : moment().subtract(4, 'month'),
      web_url: 'https://github.com/ariel-linearb/linpy',
      ...(isNew ? { isNew } : {})
    });
  }
  return repositories;
};

export const mockFetchRepositoriesResponse = [
  {
    contrib_count: -1,
    created_at: '2021-07-30T03:28:12',
    description: 'Python shared code module',
    http_url: 'https://github.com/ariel-linearb/linpy.git',
    id: 277433532,
    language: null,
    main_branch: 'develop',
    name: 'linpy',
    owner_login: 'ariel-linearb',
    owner_type: 'User',
    size: 895,
    ssh_url: 'git@github.com:ariel-linearb/linpy.git',
    updated_at: '2021-07-30T10:21:38',
    web_url: 'https://github.com/ariel-linearb/linpy'
  },
  {
    contrib_count: -1,
    created_at: '2019-09-23T11:47:14',
    description: null,
    http_url: 'https://github.com/ariel-linearb/test.git',
    id: 210341581,
    language: null,
    main_branch: 'master',
    name: 'test',
    owner_login: 'ariel-linearb',
    owner_type: 'User',
    size: 0,
    ssh_url: 'git@github.com:ariel-linearb/test.git',
    updated_at: '2019-09-23T11:53:18',
    web_url: 'https://github.com/ariel-linearb/test'
  },
  {
    contrib_count: -1,
    created_at: '2019-04-30T11:59:20',
    description: null,
    http_url: 'https://github.com/linear-b/api-gateway.git',
    id: 184254168,
    language: 'Shell',
    main_branch: 'develop',
    name: 'api-gateway',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 114,
    ssh_url: 'git@github.com:linear-b/api-gateway.git',
    updated_at: '2021-07-12T12:16:33',
    web_url: 'https://github.com/linear-b/api-gateway'
  },
  {
    contrib_count: -1,
    created_at: '2019-04-30T11:59:20',
    description: null,
    http_url: 'https://github.com/linear-b/api-gateways.git',
    id: 1842541688,
    language: 'Shell',
    main_branch: 'develop',
    name: 'api-gateway',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 114,
    ssh_url: 'git@github.com:linear-b/api-gateways.git',
    updated_at: '2021-07-12T12:16:33',
    web_url: 'https://github.com/linear-b/api-gateways'
  },
  {
    contrib_count: -1,
    created_at: '2019-04-30T11:59:20',
    description: null,
    http_url: 'https://github.com/linear-b/api-gateways.git',
    id: 1842541688,
    language: 'Shell',
    main_branch: 'develop',
    name: 'api-gateway',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 114,
    ssh_url: 'git@github.com:linear-b/api-gateways.git',
    updated_at: '2021-07-12T12:16:33',
    web_url: 'https://github.com/linear-b/api-gateways'
  },
  {
    contrib_count: -1,
    created_at: '2020-03-12T14:11:05',
    description: null,
    http_url: 'https://github.com/linear-b/auditer.git',
    id: 246851098,
    language: 'Python',
    main_branch: 'develop',
    name: 'auditer',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 37,
    ssh_url: 'git@github.com:linear-b/auditer.git',
    updated_at: '2021-06-28T14:21:27',
    web_url: 'https://github.com/linear-b/auditer'
  },
  {
    contrib_count: -1,
    created_at: '2020-01-05T13:31:41',
    description: 'Cypress e2e testing',
    http_url: 'https://github.com/linear-b/cypress-e2e.git',
    id: 231921913,
    language: 'JavaScript',
    main_branch: 'master',
    name: 'cypress-e2e',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 7064,
    ssh_url: 'git@github.com:linear-b/cypress-e2e.git',
    updated_at: '2021-07-12T15:14:56',
    web_url: 'https://github.com/linear-b/cypress-e2e'
  },
  {
    contrib_count: -1,
    created_at: '2020-03-30T08:15:28',
    description: 'test repository for diff utility testing',
    http_url: 'https://github.com/linear-b/diff-test-repo.git',
    id: 251242356,
    language: 'Python',
    main_branch: 'master',
    name: 'diff-test-repo',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 4,
    ssh_url: 'git@github.com:linear-b/diff-test-repo.git',
    updated_at: '2020-03-30T13:17:36',
    web_url: 'https://github.com/linear-b/diff-test-repo'
  },
  {
    contrib_count: -1,
    created_at: '2019-05-06T14:10:18',
    description: 'E2E Testing Repo',
    http_url: 'https://github.com/linear-b/e2e.git',
    id: 185209832,
    language: 'Python',
    main_branch: 'develop',
    name: 'e2e',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1741,
    ssh_url: 'git@github.com:linear-b/e2e.git',
    updated_at: '2021-07-12T06:13:20',
    web_url: 'https://github.com/linear-b/e2e'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-15T06:46:08',
    description: null,
    http_url: 'https://github.com/linear-b/eitan-migrator.git',
    id: 377063546,
    language: 'PLpgSQL',
    main_branch: 'main',
    name: 'eitan-migrator',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 147,
    ssh_url: 'git@github.com:linear-b/eitan-migrator.git',
    updated_at: '2021-06-15T13:40:58',
    web_url: 'https://github.com/linear-b/eitan-migrator'
  },
  {
    contrib_count: -1,
    created_at: '2020-07-03T06:09:45',
    description: 'A GraphQL implementation of our API',
    http_url: 'https://github.com/linear-b/graphql-api.git',
    id: 276821599,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'graphql-api',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1384,
    ssh_url: 'git@github.com:linear-b/graphql-api.git',
    updated_at: '2021-07-09T21:58:00',
    web_url: 'https://github.com/linear-b/graphql-api'
  },
  {
    contrib_count: -1,
    created_at: '2020-02-26T07:55:25',
    description: 'A place for all your experiments',
    http_url: 'https://github.com/linear-b/incubator.git',
    id: 243202108,
    language: null,
    main_branch: 'master',
    name: 'incubator',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 511,
    ssh_url: 'git@github.com:linear-b/incubator.git',
    updated_at: '2021-06-12T07:26:16',
    web_url: 'https://github.com/linear-b/incubator'
  },
  {
    contrib_count: -1,
    created_at: '2021-04-08T13:50:04',
    description: null,
    http_url: 'https://github.com/linear-b/infra.git',
    id: 355925895,
    language: null,
    main_branch: 'main',
    name: 'infra',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 68,
    ssh_url: 'git@github.com:linear-b/infra.git',
    updated_at: '2021-07-01T11:56:24',
    web_url: 'https://github.com/linear-b/infra'
  },
  {
    contrib_count: -1,
    created_at: '2019-05-12T07:00:25',
    description: 'linearb jenkins project repository',
    http_url: 'https://github.com/linear-b/jenkins.git',
    id: 186222557,
    language: 'Dockerfile',
    main_branch: 'develop',
    name: 'jenkins',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 10,
    ssh_url: 'git@github.com:linear-b/jenkins.git',
    updated_at: '2019-09-15T12:19:55',
    web_url: 'https://github.com/linear-b/jenkins'
  },
  {
    contrib_count: -1,
    created_at: '2018-06-03T19:45:50',
    description: 'Holds the core modules linearb data pipeline and analysis',
    http_url: 'https://github.com/linear-b/linearb.git',
    id: 135935163,
    language: 'Python',
    main_branch: 'develop',
    name: 'linearb',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 89354,
    ssh_url: 'git@github.com:linear-b/linearb.git',
    updated_at: '2021-07-12T10:00:52',
    web_url: 'https://github.com/linear-b/linearb'
  },
  {
    contrib_count: -1,
    created_at: '2018-10-03T23:32:47',
    description: 'Repository for Testing and Practicing Activations',
    http_url: 'https://github.com/linear-b/linearBactivationTestrepo.git',
    id: 151494052,
    language: null,
    main_branch: 'master',
    name: 'linearBactivationTestrepo',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1,
    ssh_url: 'git@github.com:linear-b/linearBactivationTestrepo.git',
    updated_at: '2021-06-10T15:19:19',
    web_url: 'https://github.com/linear-b/linearBactivationTestrepo'
  },
  {
    contrib_count: -1,
    created_at: '2020-09-01T09:56:29',
    description: null,
    http_url: 'https://github.com/linear-b/linenv.git',
    id: 291960767,
    language: 'Python',
    main_branch: 'develop',
    name: 'linenv',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 204,
    ssh_url: 'git@github.com:linear-b/linenv.git',
    updated_at: '2021-07-12T11:49:21',
    web_url: 'https://github.com/linear-b/linenv'
  },
  {
    contrib_count: -1,
    created_at: '2020-07-13T11:36:17',
    description: 'Holds various processing jobs for Pulse and other',
    http_url: 'https://github.com/linear-b/linjobs.git',
    id: 279285306,
    language: 'Python',
    main_branch: 'develop',
    name: 'linjobs',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 212,
    ssh_url: 'git@github.com:linear-b/linjobs.git',
    updated_at: '2021-07-02T08:01:33',
    web_url: 'https://github.com/linear-b/linjobs'
  },
  {
    contrib_count: -1,
    created_at: '2021-03-24T16:24:33',
    description: 'Shared code between linweb & node services',
    http_url: 'https://github.com/linear-b/linjs-common.git',
    id: 351148520,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'linjs-common',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 738,
    ssh_url: 'git@github.com:linear-b/linjs-common.git',
    updated_at: '2021-07-08T14:03:56',
    web_url: 'https://github.com/linear-b/linjs-common'
  },
  {
    contrib_count: -1,
    created_at: '2019-04-14T07:12:21',
    description: 'Common infrastructure for nodejs services',
    http_url: 'https://github.com/linear-b/linode-common.git',
    id: 181272929,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'linode-common',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 734,
    ssh_url: 'git@github.com:linear-b/linode-common.git',
    updated_at: '2021-07-12T19:21:12',
    web_url: 'https://github.com/linear-b/linode-common'
  },
  {
    contrib_count: -1,
    created_at: '2019-05-22T07:09:15',
    description: 'NodeJS Logger',
    http_url: 'https://github.com/linear-b/linode-logger.git',
    id: 187982881,
    language: 'JavaScript',
    main_branch: 'develop',
    name: 'linode-logger',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 138,
    ssh_url: 'git@github.com:linear-b/linode-logger.git',
    updated_at: '2021-07-07T14:04:46',
    web_url: 'https://github.com/linear-b/linode-logger'
  },
  {
    contrib_count: -1,
    created_at: '2018-12-24T06:37:12',
    description: 'Repository for building the relevant Linear B environment',
    http_url: 'https://github.com/linear-b/linops.git',
    id: 162958773,
    language: 'Shell',
    main_branch: 'develop',
    name: 'linops',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1314,
    ssh_url: 'git@github.com:linear-b/linops.git',
    updated_at: '2021-07-12T15:38:07',
    web_url: 'https://github.com/linear-b/linops'
  },
  {
    contrib_count: -1,
    created_at: '2019-04-28T05:11:51',
    description: 'Pull requests microservice',
    http_url: 'https://github.com/linear-b/linpr.git',
    id: 183858545,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'linpr',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1950,
    ssh_url: 'git@github.com:linear-b/linpr.git',
    updated_at: '2021-07-12T09:50:06',
    web_url: 'https://github.com/linear-b/linpr'
  },
  {
    contrib_count: -1,
    created_at: '2019-02-13T10:00:49',
    description: 'Python shared code module',
    http_url: 'https://github.com/linear-b/linpy.git',
    id: 170484377,
    language: 'Python',
    main_branch: 'develop',
    name: 'linpy',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 2796,
    ssh_url: 'git@github.com:linear-b/linpy.git',
    updated_at: '2021-07-13T05:56:56',
    web_url: 'https://github.com/linear-b/linpy'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-17T13:03:33',
    description: 'Shared Core utilities for Python',
    http_url: 'https://github.com/linear-b/linpy-core.git',
    id: 377832771,
    language: null,
    main_branch: 'develop',
    name: 'linpy-core',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1,
    ssh_url: 'git@github.com:linear-b/linpy-core.git',
    updated_at: '2021-06-17T13:59:30',
    web_url: 'https://github.com/linear-b/linpy-core'
  },
  {
    contrib_count: -1,
    created_at: '2018-12-12T15:56:55',
    description: 'Linear B REST data services',
    http_url: 'https://github.com/linear-b/linrest.git',
    id: 161511209,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'linrest',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 4159,
    ssh_url: 'git@github.com:linear-b/linrest.git',
    updated_at: '2021-07-13T07:11:14',
    web_url: 'https://github.com/linear-b/linrest'
  },
  {
    contrib_count: -1,
    created_at: '2020-11-16T07:29:36',
    description: "Linear-b's security utilities project",
    http_url: 'https://github.com/linear-b/linsec.git',
    id: 313222280,
    language: null,
    main_branch: 'develop',
    name: 'linsec',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 27,
    ssh_url: 'git@github.com:linear-b/linsec.git',
    updated_at: '2021-01-17T09:39:38',
    web_url: 'https://github.com/linear-b/linsec'
  },
  {
    contrib_count: -1,
    created_at: '2020-07-05T13:50:19',
    description: 'Base docker image for linta',
    http_url: 'https://github.com/linear-b/linta_base.git',
    id: 277311376,
    language: 'Dockerfile',
    main_branch: 'develop',
    name: 'linta_base',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 8,
    ssh_url: 'git@github.com:linear-b/linta_base.git',
    updated_at: '2020-07-05T19:07:36',
    web_url: 'https://github.com/linear-b/linta_base'
  },
  {
    contrib_count: -1,
    created_at: '2018-12-12T15:09:41',
    description: 'LinearB React Application',
    http_url: 'https://github.com/linear-b/linweb.git',
    id: 161505120,
    language: 'JavaScript',
    main_branch: 'develop',
    name: 'linweb',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 20329,
    ssh_url: 'git@github.com:linear-b/linweb.git',
    updated_at: '2021-07-12T17:40:42',
    web_url: 'https://github.com/linear-b/linweb'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-01T11:23:37',
    description: null,
    http_url: 'https://github.com/linear-b/linweb-eitan.git',
    id: 372804124,
    language: 'JavaScript',
    main_branch: 'develop',
    name: 'linweb-eitan',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 2120,
    ssh_url: 'git@github.com:linear-b/linweb-eitan.git',
    updated_at: '2021-06-02T09:34:13',
    web_url: 'https://github.com/linear-b/linweb-eitan'
  },
  {
    contrib_count: -1,
    created_at: '2019-12-18T12:47:34',
    description: null,
    http_url: 'https://github.com/linear-b/metrics.git',
    id: 228838746,
    language: 'Dockerfile',
    main_branch: 'develop',
    name: 'metrics',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 8,
    ssh_url: 'git@github.com:linear-b/metrics.git',
    updated_at: '2019-12-18T17:32:19',
    web_url: 'https://github.com/linear-b/metrics'
  },
  {
    contrib_count: -1,
    created_at: '2018-12-23T21:20:11',
    description: 'LinearB data migrations repository',
    http_url: 'https://github.com/linear-b/migrator.git',
    id: 162924604,
    language: 'PLpgSQL',
    main_branch: 'develop',
    name: 'migrator',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1517,
    ssh_url: 'git@github.com:linear-b/migrator.git',
    updated_at: '2021-07-12T17:05:55',
    web_url: 'https://github.com/linear-b/migrator'
  },
  {
    contrib_count: -1,
    created_at: '2019-09-21T09:48:06',
    description: 'Linear B notifications service',
    http_url: 'https://github.com/linear-b/notifier.git',
    id: 209960604,
    language: 'Python',
    main_branch: 'develop',
    name: 'notifier',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 675,
    ssh_url: 'git@github.com:linear-b/notifier.git',
    updated_at: '2021-07-12T14:08:16',
    web_url: 'https://github.com/linear-b/notifier'
  },
  {
    contrib_count: -1,
    created_at: '2020-01-19T08:30:12',
    description: null,
    http_url: 'https://github.com/linear-b/performance-worker.git',
    id: 234865910,
    language: 'Python',
    main_branch: 'develop',
    name: 'performance-worker',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 291,
    ssh_url: 'git@github.com:linear-b/performance-worker.git',
    updated_at: '2021-07-05T04:01:18',
    web_url: 'https://github.com/linear-b/performance-worker'
  },
  {
    contrib_count: -1,
    created_at: '2020-10-18T07:59:11',
    description: 'Code for the various PLG tools',
    http_url: 'https://github.com/linear-b/plg.git',
    id: 305051317,
    language: 'JavaScript',
    main_branch: 'develop',
    name: 'plg',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 14,
    ssh_url: 'git@github.com:linear-b/plg.git',
    updated_at: '2020-10-26T13:04:50',
    web_url: 'https://github.com/linear-b/plg'
  },
  {
    contrib_count: -1,
    created_at: '2019-06-04T12:50:29',
    description:
      'project for project managmeent and issue trackers data source connectors',
    http_url: 'https://github.com/linear-b/pm-connectors.git',
    id: 190200393,
    language: 'Python',
    main_branch: 'develop',
    name: 'pm-connectors',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 813,
    ssh_url: 'git@github.com:linear-b/pm-connectors.git',
    updated_at: '2021-07-07T14:07:51',
    web_url: 'https://github.com/linear-b/pm-connectors'
  },
  {
    contrib_count: -1,
    created_at: '2019-06-19T05:40:05',
    description: 'project management originated data rest service',
    http_url: 'https://github.com/linear-b/pm-rest.git',
    id: 192665636,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'pm-rest',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1291,
    ssh_url: 'git@github.com:linear-b/pm-rest.git',
    updated_at: '2021-07-10T06:09:42',
    web_url: 'https://github.com/linear-b/pm-rest'
  },
  {
    contrib_count: -1,
    created_at: '2020-05-02T06:33:25',
    description: null,
    http_url: 'https://github.com/linear-b/resources-api.git',
    id: 260628685,
    language: null,
    main_branch: 'develop',
    name: 'resources-api',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 110,
    ssh_url: 'git@github.com:linear-b/resources-api.git',
    updated_at: '2020-05-15T07:43:20',
    web_url: 'https://github.com/linear-b/resources-api'
  },
  {
    contrib_count: -1,
    created_at: '2018-12-04T05:28:29',
    description:
      'Contains integrations with the different providers Linear B connects with',
    http_url: 'https://github.com/linear-b/sensors.git',
    id: 160303506,
    language: 'Python',
    main_branch: 'develop',
    name: 'sensors',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 2174,
    ssh_url: 'git@github.com:linear-b/sensors.git',
    updated_at: '2021-07-08T10:04:24',
    web_url: 'https://github.com/linear-b/sensors'
  },
  {
    contrib_count: -1,
    created_at: '2019-11-24T08:02:16',
    description: 'Hold settings microservice',
    http_url: 'https://github.com/linear-b/settings.git',
    id: 223711285,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'settings',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 778,
    ssh_url: 'git@github.com:linear-b/settings.git',
    updated_at: '2021-06-10T18:19:36',
    web_url: 'https://github.com/linear-b/settings'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-27T08:53:37',
    description: 'Serverless server for API of messages centre ',
    http_url: 'https://github.com/linear-b/sls-app-notifications-center.git',
    id: 380693190,
    language: null,
    main_branch: 'develop',
    name: 'sls-app-notifications-center',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 115,
    ssh_url: 'git@github.com:linear-b/sls-app-notifications-center.git',
    updated_at: '2021-07-11T14:05:33',
    web_url: 'https://github.com/linear-b/sls-app-notifications-center'
  },
  {
    contrib_count: -1,
    created_at: '2021-03-07T12:46:46',
    description: null,
    http_url: 'https://github.com/linear-b/sls-custom-dashboard-api.git',
    id: 345344705,
    language: 'JavaScript',
    main_branch: 'develop',
    name: 'sls-custom-dashboard-api',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 835,
    ssh_url: 'git@github.com:linear-b/sls-custom-dashboard-api.git',
    updated_at: '2021-07-04T12:34:51',
    web_url: 'https://github.com/linear-b/sls-custom-dashboard-api'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-20T07:22:59',
    description: null,
    http_url: 'https://github.com/linear-b/sls-eitan-test.git',
    id: 378584009,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-eitan-test',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 206,
    ssh_url: 'git@github.com:linear-b/sls-eitan-test.git',
    updated_at: '2021-06-27T14:53:38',
    web_url: 'https://github.com/linear-b/sls-eitan-test'
  },
  {
    contrib_count: -1,
    created_at: '2021-01-14T06:27:19',
    description: null,
    http_url: 'https://github.com/linear-b/sls-jobs-dispatcher-lambda.git',
    id: 329527152,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-jobs-dispatcher-lambda',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 667,
    ssh_url: 'git@github.com:linear-b/sls-jobs-dispatcher-lambda.git',
    updated_at: '2021-07-13T06:16:26',
    web_url: 'https://github.com/linear-b/sls-jobs-dispatcher-lambda'
  },
  {
    contrib_count: -1,
    created_at: '2021-03-04T07:58:27',
    description: 'Internal API for LinearB Lab',
    http_url: 'https://github.com/linear-b/sls-lab-internal-api.git',
    id: 344394622,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-lab-internal-api',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 760,
    ssh_url: 'git@github.com:linear-b/sls-lab-internal-api.git',
    updated_at: '2021-07-06T08:22:02',
    web_url: 'https://github.com/linear-b/sls-lab-internal-api'
  },
  {
    contrib_count: -1,
    created_at: '2021-02-28T12:26:16',
    description: 'Gather and return metadata',
    http_url: 'https://github.com/linear-b/sls-meta-api.git',
    id: 343099438,
    language: 'TypeScript',
    main_branch: 'master',
    name: 'sls-meta-api',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 362,
    ssh_url: 'git@github.com:linear-b/sls-meta-api.git',
    updated_at: '2021-06-12T17:27:47',
    web_url: 'https://github.com/linear-b/sls-meta-api'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-29T06:16:29',
    description: 'MSTeams notifications consumer',
    http_url: 'https://github.com/linear-b/sls-msteams.git',
    id: 381259358,
    language: 'TypeScript',
    main_branch: 'develop',
    name: 'sls-msteams',
    owner_login: 'another-org',
    owner_type: 'Organization',
    size: 634,
    ssh_url: 'git@github.com:linear-b/sls-msteams.git',
    updated_at: '2021-07-12T16:46:45',
    web_url: 'https://github.com/linear-b/sls-msteams'
  },
  {
    contrib_count: -1,
    created_at: '2021-04-19T12:01:02',
    description: 'A repo for the team-digest lambda',
    http_url: 'https://github.com/linear-b/sls-notification-digest-lambda.git',
    id: 359443598,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-notification-digest-lambda',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 128,
    ssh_url: 'git@github.com:linear-b/sls-notification-digest-lambda.git',
    updated_at: '2021-07-07T07:07:27',
    web_url: 'https://github.com/linear-b/sls-notification-digest-lambda'
  },
  {
    contrib_count: -1,
    created_at: '2021-02-16T09:44:49',
    description: 'Serverless framework Off-boarding Lambda',
    http_url: 'https://github.com/linear-b/sls-off-boarding-lambda.git',
    id: 339350456,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-off-boarding-lambda',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1036,
    ssh_url: 'git@github.com:linear-b/sls-off-boarding-lambda.git',
    updated_at: '2021-07-04T12:36:16',
    web_url: 'https://github.com/linear-b/sls-off-boarding-lambda'
  },
  {
    contrib_count: -1,
    created_at: '2021-03-10T08:01:26',
    description: 'project management data collection and publish lambda',
    http_url: 'https://github.com/linear-b/sls-pm-report-lambda.git',
    id: 346277597,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-pm-report-lambda',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 292,
    ssh_url: 'git@github.com:linear-b/sls-pm-report-lambda.git',
    updated_at: '2021-07-07T07:01:59',
    web_url: 'https://github.com/linear-b/sls-pm-report-lambda'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-02T15:54:33',
    description: 'sls pm view ',
    http_url: 'https://github.com/linear-b/sls-pm-view.git',
    id: 373224818,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-pm-view',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 744,
    ssh_url: 'git@github.com:linear-b/sls-pm-view.git',
    updated_at: '2021-07-06T19:13:31',
    web_url: 'https://github.com/linear-b/sls-pm-view'
  },
  {
    contrib_count: -1,
    created_at: '2021-06-30T10:03:52',
    description: null,
    http_url: 'https://github.com/linear-b/sls-public-api.git',
    id: 381656775,
    language: null,
    main_branch: 'develop',
    name: 'sls-public-api',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 0,
    ssh_url: 'git@github.com:linear-b/sls-public-api.git',
    updated_at: '2021-06-30T10:05:42',
    web_url: 'https://github.com/linear-b/sls-public-api'
  },
  {
    contrib_count: -1,
    created_at: '2021-04-07T13:41:26',
    description: 'Rule Engine Lambda',
    http_url: 'https://github.com/linear-b/sls-rule-engine-lambda.git',
    id: 355559543,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-rule-engine-lambda',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 1129,
    ssh_url: 'git@github.com:linear-b/sls-rule-engine-lambda.git',
    updated_at: '2021-07-12T14:05:09',
    web_url: 'https://github.com/linear-b/sls-rule-engine-lambda'
  },
  {
    contrib_count: -1,
    created_at: '2021-04-15T18:24:10',
    description: null,
    http_url: 'https://github.com/linear-b/sls-scheduled-jobs-suites.git',
    id: 358354768,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-scheduled-jobs-suites',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 292,
    ssh_url: 'git@github.com:linear-b/sls-scheduled-jobs-suites.git',
    updated_at: '2021-07-12T09:31:59',
    web_url: 'https://github.com/linear-b/sls-scheduled-jobs-suites'
  },
  {
    contrib_count: -1,
    created_at: '2021-05-06T17:28:16',
    description: null,
    http_url: 'https://github.com/linear-b/sls-settings-events-lambda.git',
    id: 364987568,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-settings-events-lambda',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 86,
    ssh_url: 'git@github.com:linear-b/sls-settings-events-lambda.git',
    updated_at: '2021-07-07T07:09:00',
    web_url: 'https://github.com/linear-b/sls-settings-events-lambda'
  },
  {
    contrib_count: -1,
    created_at: '2021-05-18T14:11:22',
    description: null,
    http_url: 'https://github.com/linear-b/sls-synthetic-tests.git',
    id: 368554898,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-synthetic-tests',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 261,
    ssh_url: 'git@github.com:linear-b/sls-synthetic-tests.git',
    updated_at: '2021-07-07T07:11:11',
    web_url: 'https://github.com/linear-b/sls-synthetic-tests'
  },
  {
    contrib_count: -1,
    created_at: '2021-04-22T08:38:47',
    description: 'Serverless Framework For Webhooks',
    http_url: 'https://github.com/linear-b/sls-webhooks.git',
    id: 360449667,
    language: 'Python',
    main_branch: 'develop',
    name: 'sls-webhooks',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 146,
    ssh_url: 'git@github.com:linear-b/sls-webhooks.git',
    updated_at: '2021-07-07T07:03:36',
    web_url: 'https://github.com/linear-b/sls-webhooks'
  },
  {
    contrib_count: -1,
    created_at: '2021-01-05T09:32:39',
    description: 'Serverless webhooks',
    http_url: 'https://github.com/linear-b/sls-webhooks-internal-api.git',
    id: 326950355,
    language: 'JavaScript',
    main_branch: 'develop',
    name: 'sls-webhooks-internal-api',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 120,
    ssh_url: 'git@github.com:linear-b/sls-webhooks-internal-api.git',
    updated_at: '2021-07-04T12:36:02',
    web_url: 'https://github.com/linear-b/sls-webhooks-internal-api'
  },
  {
    contrib_count: -1,
    created_at: '2019-09-25T13:00:49',
    description:
      'The scripts/tools you have that might come in handy for everyone',
    http_url: 'https://github.com/linear-b/toolbox.git',
    id: 210846279,
    language: null,
    main_branch: 'develop',
    name: 'toolbox',
    owner_login: 'linear-b',
    owner_type: 'Organization',
    size: 2,
    ssh_url: 'git@github.com:linear-b/toolbox.git',
    updated_at: '2019-09-25T13:06:20',
    web_url: 'https://github.com/linear-b/toolbox'
  },
  {
    created_at: '2019-09-25T13:00:49',
    http_url: 'https://dev.azure.com/reshefroy/main/_git/sensors',
    id: 697870537,
    name: 'sensors',
    ssh_url: 'git@github.com:linear-b/toolbox.git',
    updated_at: '2019-09-25T13:00:49',
    web_url: 'https://github.com/linear-b/toolbox',
    organization_id: 93672499,
    sensor_id: 9,
    sensor_authorization_id: 33568
  }
];
